import Cookies from "js-cookie";

import { ISO_DATE_FORMAT, SUMMARY_DATE_FORMAT_SHORT, UK_DATE_FORMAT } from "../../const/DateFormatConsts";

import { initOfferEnquiries, initFeaturedOfferEnquiries } from "./InitOfferEnquiries";

import mountPopovers from "../../controllers/Popover.jsx";

import dayjs from "../../shared/helpers/dayjs";
import { dynamicRemarketing } from "../../shared/helpers/gtm_tracking";
import emarsys from "../../shared/helpers/emarsys";
import { json } from "../../shared/fetcher";

import { pricedPickerOptions } from "../../utils/DatePickerSupport";

const offerEnquirySelector = ".js-offer-enquiry, .js-featured-offer-enquiry";

function pushRemarketing(offer) {
  const price = parseInt(offer.querySelector("[data-from-price]").dataset.fromPrice.split("£")[1], 10);

  dynamicRemarketing({
    hrental_id: window.location.pathname.split("/")[1],
    hrental_totalvalue: price,
    hrental_pagetype: "conversionintent"
  });
}

function toggleLoadingSpinner(spinner, toggle) {
  const { classList } = spinner;

  if (toggle) {
    classList.add("is-visible");
  } else {
    classList.remove("is-visible");
  }
}

function showLoadingSpinner(spinner) {
  toggleLoadingSpinner(spinner, true);
}

function hideLoadingSpinner(spinner) {
  toggleLoadingSpinner(spinner, false);
}

function toggleOfferState(offer, toggle, ...stateClasses) {
  const classList = offer.classList;
  const slideClassList = offer.querySelector(".js-slide").classList;

  stateClasses.forEach(stateClass => {
    if (stateClass === "is-selected") {
      if (toggle) {
        slideClassList.add("is-shifted");
      } else {
        slideClassList.remove("is-shifted");
      }
    }

    if (toggle) {
      classList.add(stateClass);
    } else {
      classList.remove(stateClass);
    }
  });
}

function setOfferState(offer, ...stateClasses) {
  toggleOfferState(offer, true, ...stateClasses);
}

function unsetOfferState(offer, ...stateClasses) {
  toggleOfferState(offer, false, ...stateClasses);
}

function toggleBookButton(offer, showOrHide) {
  const bookButton = offer.querySelector(".js-booking-submit");

  if (bookButton) {
    bookButton.classList.toggle("hide", !showOrHide);
  }
}

function displayPrice(offer, price, showFrom) {
  const form = offer.querySelector(".js-enquiry-form");
  const fromText = form.querySelector(".from");
  form.querySelector(".price").textContent = price;
  if (fromText) {
    fromText.classList.toggle("hide", !showFrom);
  }
}

function hideDatePopover(offer) {
  const popover = offer.querySelector("[data-popover]");

  if (popover) {
    Cookies.set(popover.dataset.cookie, true, {
      expires: 20 * 365,
      samesite: "lax"
    });
    mountPopovers(offer);
  }
}

function setPriceHiddenInput(offer, price) {
  const priceHiddenInput = offer.querySelector("input[type=hidden][name='enquiry[price]']")
  if (priceHiddenInput) {
    priceHiddenInput.value = price.replace('£', '')
  }
}

function handleOfferDateChange(offer) {
  return function (date, datePicker) {
    const price = datePicker.getPrice(date);
    const fromPrice = offer.querySelector(".venue__offer__from-price").dataset.fromPrice;
    const includesFlights = !!offer.querySelector(".venue__offer__from-price").dataset.includesFlights;

    let inputDate;
    let labelDate;
    if (date) {
      inputDate = date.format(UK_DATE_FORMAT);
      labelDate = date.format(SUMMARY_DATE_FORMAT_SHORT);
      if (offer.querySelector(".featured-offer-enquiry")) {
        toggleBookButton(offer, !!price);
      }
      displayPrice(offer, price || fromPrice, includesFlights || !price);
      hideDatePopover(offer);
      setPriceHiddenInput(offer, price)
    } else {
      inputDate = "";
      labelDate = "select date";
      displayPrice(offer, fromPrice, true);
      setPriceHiddenInput(offer, fromPrice)
    }

    offer.querySelector(".js-offer-date").value = inputDate;
    offer.querySelector(".js-offer-date-text").textContent = labelDate;
  };
}

function loadOfferDatepicker(id, offer, date, pricingData) {
  const firstDate = dayjs(pricingData.first_date, ISO_DATE_FORMAT).format(UK_DATE_FORMAT);
  $(offer.querySelector(".js-offer-date"))
    .pickadate(pricedPickerOptions(id, handleOfferDateChange(offer), pricingData))
    .pickadate("picker")
    .set({
      select: date,
      highlight: date || firstDate
    });
}

function loadPrices(offer, spinner) {
  const id = offer.dataset.id;
  const resPackage = ("resPackage" in offer.dataset)
  const packageId = id.replace(/^featured-/, "");
  const isFeatured = packageId !== id;
  const offerDate = offer.querySelector(".js-offer-date").value;
  const arrivalDate = document.querySelector(".js-arrival-date").value;
  const selectedDate = isFeatured ? undefined : offerDate || arrivalDate || undefined;
  const pricesAPI = `/prices/calendar?package_id=${packageId}&res_package=${resPackage}`;

  json(pricesAPI)
    .then(data => {
      loadOfferDatepicker(id, offer, selectedDate, data);
      pushRemarketing(offer);
      hideLoadingSpinner(spinner);
    })
    .catch(() => {
      setOfferState(offer, "has-failed");
      hideLoadingSpinner(spinner);
    });
}

function handleOfferSelect(e) {
  e.preventDefault();
  const offer = this.closest(offerEnquirySelector);
  const spinner = offer.querySelector(".js-loading");

  setOfferState(offer, "is-selected");
  showLoadingSpinner(spinner);

  emarsys(window.emarsysCartData);
  loadPrices(offer, spinner);
}

function handleOfferBack(e) {
  e.preventDefault();
  const offer = this.closest(offerEnquirySelector);

  unsetOfferState(offer, "is-selected", "has-failed");
}

function handlePaxSelect() {
  const [first] = this.selectedOptions;
  const offer = this.closest(offerEnquirySelector);

  offer.querySelector(".js-offer-pax-text").textContent = first.text;
}

function handleOfferBookingClick(e) {
  e.preventDefault();
  const form = e.target.closest(".js-enquiry-form");
  const arrivalDate = form.querySelector("input[name='enquiry[arrival_date]']").value;

  if (form.checkValidity() && arrivalDate) {
    form.querySelector("input[name='redirect_to_payment']").value = true;
  }

  // We have to click the submit button to trigger the HTML validation
  // rather than using the .submit() method, which bypasses the validation
  form.querySelector(".js-enquiry-submit").click();
}

function onContainerClick(e) {
  const enquirySelect = e.target.closest(".js-offer-enquiry-select");
  const enquiryBack = e.target.closest(".js-offer-enquiry-back");
  const bookingSubmit = e.target.closest(".js-booking-submit");

  if (enquirySelect) {
    handleOfferSelect.bind(enquirySelect)(e);
  }

  if (enquiryBack) {
    handleOfferBack.bind(enquiryBack)(e);
  }

  if (bookingSubmit) {
    handleOfferBookingClick.bind(bookingSubmit)(e);
  }
}

function onPaxChange(e) {
  const offerPax = e.target.closest(".js-offer-pax");

  if (offerPax) {
    handlePaxSelect.call(offerPax);
  }
}

function initEventListeners() {
  const containers = [document.getElementById("offers"), document.getElementById("js-venue-intro")].filter(Boolean);

  containers.forEach(container => {
    container.addEventListener("click", onContainerClick);
    container.addEventListener("change", onPaxChange);
  });
}

function offerEnquiry() {
  initFeaturedOfferEnquiries();
  initOfferEnquiries();
  initEventListeners();
}

export default offerEnquiry;



// WEBPACK FOOTER //
// ./components/enquiries/offer_enquiry.js